<template>
  <v-dialog
    :value="true"
    max-width="650px"
    @click:outside="close"
  >
    <v-card
      :loading="dialogCopyProcessing"
    >
      <v-card-title class="headline">
        Make a Copy of {{ modelData.name }}
      </v-card-title>
      <v-card-text>
        Are you sure you want to make a copy of this product assignment model?
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="blue darken-1"
          text
          :disabled="dialogCopyProcessing"
          @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
          color="red"
          text
          :disabled="dialogCopyProcessing"
          @click="copyModel"
        >
          OK
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    modelData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialogCopyProcessing: false,
    };
  },
  methods: {
    close() {
      this.$emit('close-modal');
    },
    copyModel() {
      this.dialogCopyProcessing = true;
      this.$axios
        .post(`api/v1/product-assignment-model/${this.modelData.id}/make-copy`)
        .then((data) => {
          this.$emit('model-copied', data?.data);

          this.setNotification({
            message: 'Product assignment model has been duplicated',
            color: 'green',
          });

          this.close();
        })
        .catch((error) => {
          this.setNotification({
            message: 'There was an error processing your request.',
            color: 'red',
          });

          console.error(error);
        })
        .then(() => {
          this.dialogCopyProcessing = false;

          this.close();
        });
    },
    ...mapActions('notification', ['setNotification']),
  },
};
</script>

<style>

</style>
